export const aciBalloon = {
    iconName: 'balloon',
    iconData: [
        128,
        128,
        `M73.244 104h-1.692c-.008 4-3.392 7.515-7.541 7.515-4.166 0-7.528-3.515-7.558-7.515H54.77c-2.083 0-3.77 1.416-3.77 3.499v15.069c0 2.088 1.687 3.432 3.77 3.432h18.474c2.084 0 3.756-1.344 3.756-3.432v-15.069c0-2.083-1.672-3.499-3.756-3.499zm-16.762-6c0-17-20.771-39.017-20.771-63.423 0-23.853 16.925-32.126 26.301-32.481-3.842 1.101-9.701 9.563-9.701 32.176C52.312 58.679 61.82 81 61.82 98h4.379c0-17 9.494-39.365 9.494-63.772 0-22.612-5.855-31.031-9.69-32.132 9.386.358 26.286 8.678 26.286 32.524C92.289 58.753 71.544 80 71.544 98h5.454c0-17 31.882-39.191 31.882-63.58C108.88 10 79.711 2 65.271 2h-2.543C48.293 2 19.12 10 19.12 34.42 19.12 58.809 51.017 81 51.017 98h5.465z`,
    ],
};
